import { QueryClient } from "@tanstack/react-query";
import axios from "axios";
import { ApiError } from "@/types/api";

/** Creates one browser-lifetime query client with conservative retry behavior. */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Obsolete session requests are cancelled intentionally, never transient failures.
          if (axios.isCancel(error)) return false;
          // Client errors are deterministic; retry only transient/network/server failures.
          if (error instanceof ApiError) {
            if (
              error.kind === "invalid-response" ||
              error.kind === "unexpected"
            )
              return false;
            const status = error.status ?? 0;
            if (status >= 400 && status < 500) return false;
          }

          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}
